module.exports = __webpack_public_path__ + "media/images/img_step_arrow-2efc995072ca64f45db7f4aa31c34b81.png";